/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/territory_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";
import { common } from "../../../../common";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/territory_remote_lookup_provider.rb) */
export const itemTypeSchema = z.strictObject({
  id: common.objectId,
  name: z.string(),
  archived: z.boolean().nullable().optional(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/territory_remote_lookup_provider.rb) */
export const itemTypeOutputSchema = z.object({
  id: common.objectId,
  name: z.string(),
  archived: z.boolean(),
});
